import { HermesCollapse } from "@/backoffice/hermes-ui";

type BackofficeNavSectionTitleProps = {
  children: string;
  /** Menu recolhido: o título se recolhe animado, sobrando só os ícones dos itens. */
  isCollapsed: boolean;
};

/** O título de uma seção do menu ("Gestão", "Financeiro"...), só texto, sem ícone. */
export const BackofficeNavSectionTitle = ({
  children,
  isCollapsed,
}: BackofficeNavSectionTitleProps) => (
  <HermesCollapse open={!isCollapsed}>
    <p className="text-hermes-muted-fg px-3 pt-1 pb-1.5 text-[0.6875rem] font-semibold tracking-wide uppercase">
      {children}
    </p>
  </HermesCollapse>
);
